module.exports = __webpack_public_path__ + "static/media/Eyes_brown.c7cc6350.svg";